import { render } from "./EditIcon.vue?vue&type=template&id=a160327a"
const script = {}
script.render = render

export default script